import { lazyInit } from '@mail-core/std/fn/lazy/lazyInit';
import { createWindowOpen } from '@mail-core/std/fn/specific/createWindowOpen';
import config from 'Cloud/config';

export const opener = function (url, currentPage = false) {
    let win;
    const target = currentPage ? '_self' : '_blank';

    try {
        if (config.get('IS_DESKTOP_CHROME')) {
            win = window.open(url, target, 'toolbar=yes, location=yes, status=yes, menubar=yes, scrollbars=yes, noopener=true');
        } else {
            win = window.open(url, target);
            if (win) {
                win.focus();
            }
        }

        if (win) {
            win.opener = null;
        }
    } catch (error) {
        console.error(error);
    }
};

export const openerDelayed = (url, delayTimeMs = 200, currentPage = false) => {
    setTimeout(() => opener(url, currentPage), delayTimeMs);
};

export default opener;

const lazyVkTeamsBridge = lazyInit(() => import('reactApp/modules/vkTeam/vkTeam.module').then((e) => e.vkTeamsBridge));

export const { windowOpen } = createWindowOpen({
    features: {
        IS_CHROME: config.get('IS_DESKTOP_CHROME'),
        IS_IOS: config.get('IS_IOS'),
        IS_VK_MINI_APP: false,
        IS_WEBVIEW: config.get('IS_VKT_WEBVIEW'),
    },
    webviewBridge: async (url) => (await lazyVkTeamsBridge()).send('OpenLink', { url }),
    format: null,
});
